module.exports = __webpack_public_path__ + "img/icon-choice.e0bd36f8.svg";